import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ButtonModule } from '../../notes/button/button.module';

import { IndexPageComponent } from './index-page.component';

@NgModule({
  declarations: [IndexPageComponent],
  imports: [CommonModule, ButtonModule],
  exports: [IndexPageComponent],
})
export class IndexPageModule {}
